import { DialogContent, DialogAwareContentContainer, Divider } from "@/components";
import { TokenAmount, WithdrawLockForm } from "@/components";
import { formatTokenAmountForDisplay } from "@/utils";
import { DEFAULT_LOCK_TOKEN } from "@/config";
import { PostHogEvent } from "@/posthog/posthog-capture-names";
import { useEffect, useRef } from "react";
import { PosthogHelper } from "@/posthog/posthog-helper";
import { useUserTvl } from "@/hooks/infinifi/useUserTvl";
import { useAccount } from "wagmi";

export interface WithdrawLockFormDialogProps {
    existingLockAmount: number;
    existingDuration: number;
}

export function WithdrawLockFormDialog({ existingLockAmount, existingDuration }: WithdrawLockFormDialogProps) {
    const { address } = useAccount();
    const { userTotalTvl } = useUserTvl();

    const opened = useRef(false);

    useEffect(() => {
        if (!opened.current) {
            opened.current = true;
            try {
                PosthogHelper.capture({
                    event_name: PostHogEvent.WithdrawLockFormDialog.opened,
                    properties: {
                        existingLockAmount,
                        duration: existingDuration,
                        userTotalTvl,
                        userAddress: address,
                    },
                    userIdentifier: address,
                    allowTemporaryOptIn: false,
                });
            } catch (error) {
                console.error("Error capturing posthog event:", error);
            }
        }
    }, [existingLockAmount, existingDuration, address]);

    return (
        <DialogContent>
            <DialogAwareContentContainer isDialog>
                <div className="flex justify-between items-center text-[16px] leading-8 text-dark">
                    <div>Locked amount</div>
                    <TokenAmount
                        amount={formatTokenAmountForDisplay(existingLockAmount?.toString())}
                        tokenId={DEFAULT_LOCK_TOKEN}
                        className="text-[16px]"
                        slotProps={{
                            amount: { className: "text-[16px] leading-8" },
                            symbol: { className: "text-[16px] leading-8" },
                        }}
                    />
                </div>
                <div className="flex justify-between items-center text-[16px] leading-8 text-dark">
                    <div>Unlock duration</div>
                    <div>
                        {existingDuration} week{existingDuration === 1 ? "" : "s"}
                    </div>
                </div>
                <Divider />
            </DialogAwareContentContainer>

            <WithdrawLockForm existingLockAmount={existingLockAmount} existingLockDuration={existingDuration} />
        </DialogContent>
    );
}
